export default {
  acidity: `De zuurgraad is een van de belangrijkste pijlers van wijn.
    De hoeveelheid zuren hangt vaak samen met het gebied waar de wijn vandaan komt.
    Hoe noordelijker, hoe minder warmte en hoe meer zuren.
    Maar vaar niet blind op het gebied, ook het druivenras is belangrijk.
    Zo hebben sauvignon blanc, sangiovese of pinot noir bijvoorbeeld een hoge zuurgraad.
    Deze zijn hierdoor vrij fris van smaak.`,
  sweetness: `Je raadt het al: het suikergehalte gaat over de zoetheid van de wijn.
    Bij een echte zoete wijn proef je meteen en duidelijk een zoete smaak in je mond.
    Maar ook in andere wijnen proef je vaak een klein ‘zoetje’.`,
  intensity: `De smaakintensiteit van een wijn kun je goed vergelijken met de hoeveelheid ‘lux’ (of watt) in een lamp.
    Geeft een lamp zacht licht of is-ie juist fel. Vertaal je dat naar wijn: heeft een wijn veel of weinig smaak?
    Een wijn die ‘heel erg binnenkomt’ heeft een hoge smaakintensiteit.
    Bij een wijn met een subtiele smaak is de intensiteit juist laag.`,
  complexity: `Verfijning is een mooi woord voor wat je allemaal in een wijn kunt proeven en ruiken.
    Wat zijn de zogenaamde ‘smaaklaagjes’. Proef je alleen vanille. Of toch ook tropisch fruit?
    Of misschien wel citrus, anijs of iets rokerigs.
    Ruik en proef je veel verschillende smaakjes, dan heeft een wijn veel verfijning.`,
  tannin: `Tannines (of looizuren) zitten in het schilletje en de pitjes van de druif
    en komen tijdens het gistingsproces in rode wijn.
    De tannines zorgen voor ‘bite’ of soms een beetje streng mondgevoel in de rode wijn.
    Hoe meer tannines, hoe meer ‘bite’ in de wijn. En hoe langer je ‘m kunt bewaren. Als je dat al zou willen...`
}
